import { type ReactNode, useEffect, useRef } from "react";
import { useAuthStore } from "@/store/authStore";
import { fetchMe } from "@/services/auth";
import { apiConfig } from "@/services/api";

/**
 * AuthProvider · 启动时若 store 有 accessToken 但 user 缺失（如刷新页）
 * → 自动 /me 拉真 user · 失败则清空 auth
 * mock 模式跳过 /me（user 已经在 store）
 */
export function AuthProvider({ children }: { children: ReactNode }) {
  const accessToken = useAuthStore((s) => s.accessToken);
  const user = useAuthStore((s) => s.user);
  const setUser = useAuthStore((s) => s.setUser);
  const logout = useAuthStore((s) => s.logout);
  const verified = useRef(false);

  useEffect(() => {
    if (apiConfig.useMock) return;
    if (verified.current) return;
    if (!accessToken) return;
    if (user) return;
    verified.current = true;
    fetchMe()
      .then((u) => setUser(u))
      .catch(() => logout());
  }, [accessToken, user, setUser, logout]);

  useEffect(() => {
    if (user) {
      document.documentElement.dataset.role = user.role;
    } else {
      delete document.documentElement.dataset.role;
    }
  }, [user]);

  return <>{children}</>;
}
